import { formatToNaira } from '../../../../../helpers/utils';
import { formatIpoDate, getIpoApiStatusTag } from '../../../../../helpers/utils/investify';
import { IpoSubscriptionsTableProps } from '../../../../../types';

const IpoSubscriptionsTable = ({ rows, onRowClick }: IpoSubscriptionsTableProps) => (
  <div className="table-container ipo-subscriptions">
    <table className="table">
      <thead className="table_head">
        <tr>
          <th>Subscription ID</th>
          <th>Offer Name</th>
          <th className="numeric">Units</th>
          <th className="numeric">Amount</th>
          <th>Submitted</th>
          <th>Status</th>
        </tr>
      </thead>
      <tbody className="table-body">
        {rows.map((row) => {
          const status = getIpoApiStatusTag(row.status);

          return (
            <tr key={row.id} className="table-row pointer" onClick={() => onRowClick(row)}>
              <td className="reference">{row.id}</td>
              <td className="offer" title={row.offerName}>
                {row.offerName || '—'}
              </td>
              <td className="numeric">{Number(row.numberOfUnits || 0).toLocaleString()}</td>
              <td className="numeric">{formatToNaira(Number(row.subscriptionAmount || 0))}</td>
              <td>{formatIpoDate(row.submissionDate)}</td>
              <td>
                <p className={`mode ${status.tagClass}`}>{status.label}</p>
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  </div>
);

export default IpoSubscriptionsTable;
